module.exports = __webpack_public_path__ + "static/Alisa-tablet-a3723c09724e117a784fa6a78188fd67.jpg";